import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.element.querySelector('input#cancel-attendances').addEventListener('change', (ev) => {
      this.element.querySelector('#credit-attendances-wrapper').classList.toggle('hidden', !ev.currentTarget.checked);
    });

    this.element.querySelector('#full-day').addEventListener('click', (ev) => {
      this.element.querySelector('#end-date-wrapper').classList.toggle('hidden', ev.currentTarget.checked);
    });
  }
}